@if (!isDeleted() || undoDeleteEnabled()) {
    <div class="flex flex-row w-full justify-between items-center">
        <div class="flex flex-row items-center gap-2 min-w-0">
            <div><span class="text-2xl element-document"></span></div>
            <div class="flex flex-col min-w-0">
                <div
                    class="wrap-anywhere"
                    [class.text-danger]="isDeleted()"
                >
                    {{ fileName() }}
                </div>
                @if (fileSize(); as size) {
                    <div class="text-xs text-secondary">
                        {{ size }}
                    </div>
                }
            </div>
        </div>
        <div class="p-1 flex flex-row gap-2 shrink-0">
            @if (downloadEnabled()) {
                <tran-icon-button
                    icon="download"
                    [title]="'common.download' | translate: { fileName: fileName() }"
                    [ariaLabel]="'common.download' | translate: { fileName: fileName() }"
                    (clicked)="download.emit()"
                />
            }
            @if (deleteEnabled() && !isDeleted()) {
                <tran-icon-button
                    icon="delete"
                    btnType="danger"
                    [title]="'common.delete' | translate: { fileName: fileName() }"
                    [ariaLabel]="'common.delete' | translate: { fileName: fileName() }"
                    (clicked)="delete.emit()"
                />
            }
            @if (deleteEnabled() && undoDeleteEnabled() && isDeleted()) {
                <tran-icon-button
                    icon="undo"
                    [title]="'common.undo' | translate: { fileName: fileName() }"
                    [ariaLabel]="'common.undo' | translate: { fileName: fileName() }"
                    (clicked)="undoDelete.emit()"
                />
            }
        </div>
    </div>
}
